export interface OutcomeFields {
  successfulOutcome?: {
    successfulAttempt: number;
    provider: string | null;
    requestedModelId: string | null;
    providerModel: string | null;
    generationLogId?: string;
  } | null;
  generationOutcome?: { source: 'runtime' | 'generation_log_backfill' } | null;
  outcomeSource?: 'reservation' | 'generation_log' | 'unknown';
  outcomeConflict?: boolean;
}

export default function GenerationOutcomeSummary({ row }: { row: OutcomeFields }) {
  const outcome = row.successfulOutcome;
  if (!outcome) return null;
  const source =
    row.outcomeSource === 'reservation'
      ? row.generationOutcome?.source === 'generation_log_backfill'
        ? 'Saved credit summary · backfilled from generation log'
        : 'Saved credit summary · recorded at confirmation'
      : 'Generation log · legacy record';
  return (
    <section aria-label="Successful generation outcome">
      <p>
        <strong>Successful attempt: {outcome.successfulAttempt}</strong>
      </p>
      <p>
        Provider: {outcome.provider || 'Not recorded'} · Provider model:{' '}
        {outcome.providerModel || 'Not recorded'}
      </p>
      <p>Requested model: {outcome.requestedModelId || 'Not recorded'}</p>
      <p>
        <small>{source}</small>
      </p>
      {row.outcomeConflict ? (
        <p className="gu-error-text">
          The generation log differs from the saved credit summary. Credit attribution uses the saved summary.
        </p>
      ) : null}
    </section>
  );
}
